const bread = {
  state: {
    breads: []
  },
  mutations: {
    SET_BREADCRUMB: (state, data) => {
      state.breads = data
    },
    APPEND_BREADCRUMB: (state, data) => {
      state.breads.push(data)
    },
    REMOVE_BREADCRUMB: (state) => {
      state.breads.pop()
    }
  },
  actions: {
    setBreadcrumb({ commit }, breads) {
      commit('SET_BREADCRUMB', breads)
    },
    appendBreadcrumb({ commit }, breadItem) {
      commit('APPEND_BREADCRUMB', breadItem)
    },
    removeBreadcrumb({ commit }, breadItem) {
      commit('REMOVE_BREADCRUMB', breadItem)
    }
  }
}

export default bread
